module.exports = __webpack_public_path__ + "img/rewards_hero.070cc7a5.png";